import { render, staticRenderFns } from "./ItemTransactions.vue?vue&type=template&id=5424121a"
import script from "./ItemTransactions.vue?vue&type=script&lang=js"
export * from "./ItemTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports